import { DatiqGraphCardChartLabel } from './datiq-graph-card-chart.enum';
import { z } from 'zod';

export const DatiqGraphCardChartDataSchema = z.object({
    actual: z.array(z.number()),
    upper: z.array(z.number()).optional(),
    lower: z.array(z.number()).optional(),
});

export const DatiqGraphCardChartSchema = z.object({
    current: z.number(),
    data: DatiqGraphCardChartDataSchema,
    labelType: z.nativeEnum(DatiqGraphCardChartLabel).optional(),
    positiveColor: z.string().optional(),
    negativeColor: z.string().optional(),
    neutralColor: z.string().optional(),
    width: z.number().optional(),
    useColor: z.boolean().optional(),
    useStrictMinMax: z.boolean().optional(),
});

export interface IDatiqGraphCardChartData
    extends z.infer<typeof DatiqGraphCardChartDataSchema> {}

export interface IDatiqGraphCardChart
    extends z.infer<typeof DatiqGraphCardChartSchema> {}
